import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { useNamedContainersWithChildren } from '@alfa-bank/site-named-container/utils';

import { useModalContext } from '../../context';

import type { THeaderProps } from './models';
import { fontsTypes } from './config';

export const Header: FC<THeaderProps> = ({
    Modal,
    Text,
    TextHolder,
    children,
    className,
    classNames,
    closerIcon: closerIconRender,
    hasBackButton,
    hasCloser,
    onBack,
    sticky = true,
    styles,
    title,
    titleView,
}) => {
    const { handleClose, size } = useModalContext();
    const { bottomSlot, children: otherChildren } = useNamedContainersWithChildren(children);

    const hasChildren = title || otherChildren?.length > 0;

    return (
        <Modal.Header
            backButtonClassName={classNames?.backButton}
            bottomAddons={bottomSlot}
            className={cn(
                styles.external,
                styles.modalV2Header,
                {
                    [styles.modalV2HeaderTitleOnly]: title && !hasBackButton,
                    [styles.modalV2HeaderBackButtonOnly]: !title && hasBackButton,
                },
                className
            )}
            closerClassName={classNames?.closer}
            closerIcon={closerIconRender ? () => closerIconRender : undefined}
            contentClassName={classNames?.content}
            hasBackButton={hasBackButton}
            hasCloser={hasCloser}
            /** TODO: Подумать, нужен ли обработчки закрытия передавать в обработчик перехода назад
             *  типы у них разные, коры не предполагали такой логики
             */
            onBack={(onBack || handleClose) as VoidFunction}
            sticky={sticky}
        >
            {hasChildren ? (
                <>
                    {title && (
                        <Text styler={{ margin: 0 }} view={titleView ?? fontsTypes[size]}>
                            <TextHolder text={title} />
                        </Text>
                    )}
                    {otherChildren}
                </>
            ) : null}
        </Modal.Header>
    );
};
